import { fetch_json_endpoint, onErrorResponse } from "typescript_helpers"

const URL_GET_ALL_USERS_AND_ROLES = "https://api.hchs.hamburg/api_endpoints/get_all_users_and_roles.php";

export async function db_get_all_users_and_roles(requestor_mail, auth_token) {
  const request_body = {
    jwt: auth_token,
    mail: requestor_mail
  }
  const response = await fetch_json_endpoint(
    URL_GET_ALL_USERS_AND_ROLES,
    request_body
  );
  try {
    onErrorResponse(response)
  } catch (error) {
    throw error;
  }
  return response;
}
